import '/assets/styles/sections/footer.scss';

export const Footer = () => {
	return (
		<footer className="section footer">
			<div className="wrapper">
				2024, TLA | Contact us on <a href="mailto:hello@wearetla.com">hello@wearetla.com</a>
			</div>
		</footer>
	)
}

export default Footer;